import { Messages } from '~src/codegen/Localize';
import { AskDataIndexing, IDataSourceBase } from '~src/datasource/models/IDataSourceInfo';
import { DataSources } from '~src/datasource/resources/Datasources';
import { ISetDatasourceAskDataSettingsParams } from '~src/datasource/ServerApi/requests/SetDatasourceAskDataSettingsRequest';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

export namespace ChangeDatasourceAskDataAction {

  export function execute(datasource: IDataSourceBase, indexing: AskDataIndexing): Promise<IResult> {
    const params: ISetDatasourceAskDataSettingsParams = {
      id: Number(datasource.id),
      indexing: indexing,
    };

    return DataSources.setAskDataSettings(params).then(response => {
      if (response.errors && response.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: Messages.dataSourceNlpSetting_failed() });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.datasourceAskData_edit_sucessful() });
      }
      return response;
    });
  }
}

export type ChangeDatasourceAskDataAction = typeof ChangeDatasourceAskDataAction;
